import { format, formatDistanceToNow } from 'date-fns';
import moment from 'moment';

export function fDate(date: string) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date: any) {
  return format(new Date(date), 'dd MMM yyyy h:mm a');
}

export function newfDateTime(date: any) {
  return format(new Date(date), 'yyyy-MM-dd HH:mm:ss');
}

export function fDateTimeSuffix(date: any) {
  return format(new Date(date), 'dd/MM/yyyy HH:mm');
}

export function fToNow(date: any) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export const shortWeekday = (weekday: string): string => {
  return weekday.substring(0, 3); // Shorten the weekday to first three letters
};

export const shortMonth = (month: string): string => {
  return moment().month(month).format("MMM"); // Shorten the month to its abbreviation
};

/**
 * Format a calendar delivery day as DD/MM/YYYY without browser timezone shift.
 * Supports `YYYY-MM-DD` and ISO strings like `2026-08-06T00:00:00.000Z`.
 */
export const formatDate = (date: string) => {
  if (!date) return '';

  const value = String(date).trim();
  const isoDay = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDay) {
    const [, year, month, day] = isoDay;
    return `${day}/${month}/${year}`;
  }

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
    return value;
  }

  // Last resort: use UTC date parts to avoid local TZ off-by-one
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  const day = String(parsed.getUTCDate()).padStart(2, '0');
  const month = String(parsed.getUTCMonth() + 1).padStart(2, '0');
  const year = parsed.getUTCFullYear();
  return `${day}/${month}/${year}`;
};
export const formatTime = (date: string) => new Date(date).toLocaleTimeString();
export const getMonth = (date: Date) => parseInt(moment(date).format('M'));
export const getYear = (date: Date) => parseInt(moment(date).format('YYYY'));
export const getMonthNameFromNumber = (number: string) =>
  moment(number, 'MM').format('MMM');
export const DateFormat = (date: Date) => formatDate(String(date));

const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };

export const formatDateAccordingToName = (date: string) => {
  const newDate = new Date(date);
  return newDate.toLocaleDateString(undefined, options);
};


export const parseDateToStartTimestamp = (dateString: string) => {
  return moment(dateString).startOf('day').valueOf();
};

export const parseDateToEndTimestamp = (dateString: string) => {
  return moment(dateString).endOf('day').valueOf();
};